var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "300", color: "white" },
      model: {
        value: _vm.popupData.user,
        callback: function($$v) {
          _vm.$set(_vm.popupData, "user", $$v)
        },
        expression: "popupData.user"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "px-3 py-3" },
        [
          _c("v-card-text", { staticClass: "text-center py-3 px-0" }, [
            _c("p", { staticClass: "mb-0 text-caption lh-20 color-7d7d7d" }, [
              _vm._v("Mobile Number")
            ]),
            _c("p", { staticClass: "black--text text-h6 lh-20 mb-1" }, [
              _vm._v(" " + _vm._s(_vm.popupData.user.mobile || "Unused") + " ")
            ])
          ]),
          _c("hr"),
          _c(
            "v-card-text",
            {
              staticClass: "text-center py-3 px-0",
              style: { display: "flex", "justify-content": "space-between" }
            },
            [
              _c("div", [
                _c(
                  "p",
                  { staticClass: "mb-0 text-caption lh-20 color-7d7d7d" },
                  [_vm._v("Date")]
                ),
                _c(
                  "p",
                  { staticClass: "black--text text-caption lh-20 mb-1" },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.dateFormat(_vm.popupData.user.planStartTime)
                        ) +
                        " "
                    )
                  ]
                )
              ]),
              _c("div", [
                _c(
                  "p",
                  { staticClass: "mb-0 text-caption lh-20 color-7d7d7d" },
                  [_vm._v("Time")]
                ),
                _c(
                  "p",
                  { staticClass: "black--text text-caption lh-20 mb-1" },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.timeFromDatTime(_vm.popupData.user.planStartTime)
                        ) +
                        " "
                    )
                  ]
                )
              ]),
              _c("div", [
                _c(
                  "p",
                  { staticClass: "mb-0 text-caption lh-20 color-7d7d7d" },
                  [_vm._v("Amount")]
                ),
                _c(
                  "p",
                  { staticClass: "black--text text-caption lh-20 mb-1" },
                  [
                    _vm._v(
                      " " + _vm._s("₹ " + _vm.popupData.user.charges) + " "
                    )
                  ]
                )
              ])
            ]
          ),
          _c("hr"),
          _c(
            "v-card-text",
            {
              staticClass: "text-center py-3 px-0",
              style: { display: "flex", "justify-content": "space-between" }
            },
            [
              _c("div", [
                _c(
                  "p",
                  { staticClass: "mb-0 text-caption lh-20 color-7d7d7d" },
                  [_vm._v("Plan")]
                ),
                _c(
                  "p",
                  { staticClass: "black--text text-caption lh-20 mb-1" },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.popupData.user.dataLimit
                            ? _vm.dataFormat(
                                _vm.popupData.user.dataLimit * 1024 * 1024
                              )
                            : "NA"
                        ) +
                        " / " +
                        _vm._s(
                          _vm.popupData.user.timePlan
                            ? _vm.timeFormat(_vm.popupData.user.timePlan)
                            : "NA"
                        ) +
                        " "
                    )
                  ]
                )
              ]),
              _c("div", [
                _c(
                  "p",
                  { staticClass: "mb-0 text-caption lh-20 color-7d7d7d" },
                  [_vm._v("Status")]
                ),
                _c(
                  "p",
                  { staticClass: "black--text text-caption lh-20 mb-1" },
                  [
                    _c("img", {
                      staticStyle: { "vertical-align": "middle" },
                      attrs: {
                        src:
                          "https://i2e1components.s3.ap-south-1.amazonaws.com/wiom-dashboard/img/icons/" +
                          _vm.templateModel.status +
                          ".svg"
                      }
                    }),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "text-transform": "capitalize",
                          "margin-left": ".25rem"
                        }
                      },
                      [_vm._v(_vm._s(_vm.templateModel.status))]
                    )
                  ]
                )
              ]),
              _c("div", [
                _c(
                  "p",
                  { staticClass: "mb-0 text-caption lh-20 color-7d7d7d" },
                  [_vm._v("Medium")]
                ),
                _c(
                  "p",
                  { staticClass: "black--text text-caption lh-20 mb-1" },
                  [
                    _c("img", {
                      staticStyle: { "vertical-align": "middle" },
                      attrs: { src: require("img/icons/wallet.svg") }
                    }),
                    _vm.popupData.user.charges == 0
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              "text-transform": "capitalize",
                              "margin-left": ".25rem"
                            }
                          },
                          [_vm._v("Free")]
                        )
                      : _c(
                          "span",
                          {
                            staticStyle: {
                              "text-transform": "capitalize",
                              "margin-left": ".25rem"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.popupData.user.extraData.payment_mode ||
                                  "cash"
                              )
                            )
                          ]
                        )
                  ]
                )
              ])
            ]
          ),
          _c("hr"),
          _vm.popupData.user.extraData.sent_to
            ? _c(
                "v-card-text",
                {
                  staticClass: "text-center py-3 px-0",
                  style: { display: "flex", "justify-content": "space-between" }
                },
                [
                  _vm.popupData.user.extraData.sent_to
                    ? _c("div", [
                        _c(
                          "p",
                          {
                            staticClass: "mb-0 text-caption lh-20 color-7d7d7d"
                          },
                          [_vm._v("Sent to")]
                        ),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "text-transform": "capitalize",
                              "margin-left": ".25rem"
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.popupData.user.extraData.sent_to) +
                                " "
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _c("div", [
                    _c(
                      "p",
                      { staticClass: "mb-0 text-caption lh-20 color-7d7d7d" },
                      [_vm._v("Coupon code")]
                    ),
                    _c(
                      "p",
                      {
                        staticClass: "text-h6 lh-20 mb-1",
                        attrs: { color: "#ff7700" }
                      },
                      [_vm._v(" " + _vm._s(_vm.popupData.user.otp) + " ")]
                    )
                  ])
                ]
              )
            : _vm._e(),
          _vm.popupData.type == _vm.myTypes.ISSUED_COUPON ? _c("hr") : _vm._e(),
          _c(
            "v-card-actions",
            {
              style: {
                display: "flex",
                "justify-content": "space-around",
                padding: "1rem 1rem 0 1rem"
              }
            },
            [
              _vm.buttons.GREY
                ? _c(
                    "v-btn",
                    {
                      staticClass: "text-capitalize",
                      style: { background: "white" },
                      attrs: { depressed: "", outlined: "" },
                      on: {
                        click: function($event) {
                          return _vm.buttons.GREY.action()
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.buttons.GREY.text) + " ")]
                  )
                : _vm._e(),
              _vm.buttons.RED
                ? _c(
                    "v-btn",
                    {
                      staticClass: "text-capitalize btn-gredient",
                      attrs: { color: "error" },
                      on: {
                        click: function($event) {
                          return _vm.buttons.RED.action()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.buttons.RED.text))]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }